import { yup } from '@framework/validation';
import { IWidgetOption } from '../../../../../Widget';
import {
  widgetOptionDividerValidator,
  widgetOptionValueValidator,
} from '../util/widgetOptionValidator';

/**
 * Utilizza correttamente il validatore in base al tipo di option validata.
 */
export const widgetOptionValidator = yup.lazy(
  (value: IWidgetOption | undefined) => {
    if (!value || value.type === 'option') {
      return widgetOptionValueValidator;
    } else {
      return widgetOptionDividerValidator;
    }
  },
);

export const widgetOptionArrayValidator = yup
  .array(widgetOptionValidator)
  .optional()
  .default([]);
